
export const LOGO = {
    src: "/logo.svg",
    alt: `${import.meta.env.VITE_PROJECT_NAME} Logo`
}

export const PROJECT_NAME = import.meta.env.VITE_PROJECT_NAME || "Qolca Solutions"